import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import { csSession } from "./auth/session";

import CSHealth from "./screens/CSHealth";

import Register from "./pages/public/Register";
import Login from "./pages/public/Login";
import VerifyPhone from "./pages/user/VerifyPhone";
import SubmitDocs from "./pages/user/SubmitDocs";
import Dashboard from "./pages/user/Dashboard";
import Payments from "./pages/user/Payments";

import UsersList from "./pages/admin/UsersList";
import UserDetail from "./pages/admin/UserDetail";
import PaymentSuccess from "./screens/CSuccess.jsx";
import PaymentError from "./screens/CError.jsx";

import ResetPassword from "./pages/public/ResetPassword";

const ADMIN_PHONE_UI = "0773134223";     // UI format
const ADMIN_PHONE_BACK = "994773134223"; // backend format da gələ bilər

function normalizeToUiPhone(p) {
  const s = String(p || "").replace(/\s+/g, "");
  if (!s) return "";
  if (s.startsWith("994")) return "0" + s.slice(3);
  if (s.startsWith("+994")) return "0" + s.slice(4);
  return s;
}

function isAuthed() {
  return Boolean(csSession.getUser()) && Boolean(csSession.getPhone?.() || csSession.getUser()?.phone);
}

function isAdmin() {
  const phone = csSession.getPhone?.() || csSession.getUser()?.phone;
  const ui = normalizeToUiPhone(phone);
  return ui === ADMIN_PHONE_UI || String(phone || "") === ADMIN_PHONE_BACK;
}

function HomeRedirect() {
  if (!isAuthed()) return <Navigate to="/couriersub/login" replace />;
  return isAdmin()
    ? <Navigate to="/couriersub/admin/users" replace />
    : <Navigate to="/couriersub/dashboard" replace />;
}

// login/register kimi public səhifələr: daxil olubsa içəri buraxma
function PublicOnly({ children }) {
  if (!isAuthed()) return children;
  return isAdmin()
    ? <Navigate to="/couriersub/admin/users" replace />
    : <Navigate to="/couriersub/dashboard" replace />;
}

// user səhifələri: login yoxdursa login-ə at
function RequireAuth({ children }) {
  if (!isAuthed()) return <Navigate to="/couriersub/login" replace />;
  if (isAdmin()) return <Navigate to="/couriersub/admin/users" replace />;
  return children;
}

// admin səhifələri: admin deyilsə dashboard-a at
function RequireAdmin({ children }) {
  if (!isAuthed()) return <Navigate to="/couriersub/login" replace />;
  if (!isAdmin()) return <Navigate to="/couriersub/dashboard" replace />;
  return children;
}

export default function CouriersubApp() {
  return (
    <div style={{ minHeight: "100vh" }}>
      <Routes>
        <Route path="/" element={<HomeRedirect />} />

        <Route path="/health" element={<CSHealth />} />

        <Route
          path="/register"
          element={
            <PublicOnly>
              <Register />
            </PublicOnly>
          }
        />
        <Route
          path="/login"
          element={
            <PublicOnly>
              <Login />
            </PublicOnly>
          }
        />

        <Route
          path="/verify"
          element={
            <RequireAuth>
              <VerifyPhone />
            </RequireAuth>
          }
        />
        <Route
          path="/docs"
          element={
            <RequireAuth>
              <SubmitDocs />
            </RequireAuth>
          }
        />
        <Route
          path="/dashboard"
          element={
            <RequireAuth>
              <Dashboard />
            </RequireAuth>
          }
        />
        <Route
          path="/payments"
          element={
            <RequireAuth>
              <Payments />
            </RequireAuth>
          }
        />

        <Route
          path="/admin/users"
          element={
            <RequireAdmin>
              <UsersList />
            </RequireAdmin>
          }
        />
        <Route
          path="/admin/users/:id"
          element={
            <RequireAdmin>
              <UserDetail />
            </RequireAdmin>
          }
        />

        <Route
          path="/reset-password"
          element={
            <PublicOnly>
              <ResetPassword />
            </PublicOnly>
          }
        />

        <Route path="/success" element={<PaymentSuccess />} />
        <Route path="/error" element={<PaymentError />} />

        {/* unknown */}
        <Route path="*" element={<HomeRedirect />} />
      </Routes>
    </div>
  );
}

